export default __webpack_public_path__ + "static/media/Anova-Light.61451639.woff2";